import { Component, OnInit, Input, OnDestroy, ChangeDetectorRef, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ChamelionOffer } from '@app/models/offerpack/ChamelionOffer';
import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'clever-chamaeleon-detail',
    templateUrl: './chamaeleon-detail.component.html',
    styleUrls: ['./chamaeleon-detail.component.scss'],
    standalone: false
})
export class ChamealeonDetailComponent implements OnInit, OnDestroy, AfterViewInit {
    @Input() datas: ChamelionOffer;
    @Output() sendReg: EventEmitter<boolean> = new EventEmitter();
    private unsubscribe$ = new Subject();

    deskMode: boolean = true;

    curentContent: number = 0;

    constructor(
        protected mediaObserver: BreakpointObserver,
        private cdr: ChangeDetectorRef
    ) {
        if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.deskMode = false;
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.deskMode = false;
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.deskMode = false;
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.deskMode = true;
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.deskMode = true;
        }
    }

    ngOnInit(): void {
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            const cont = document.getElementById('rigth-modal-content');
            const mydideo = document.getElementById('c-videos');
            fromEvent(cont, 'scroll').pipe(
                takeUntil(this.unsubscribe$)
            ).subscribe(() => {
                if (mydideo.offsetTop - cont.scrollTop < 600) {
                    this.curentContent = 1;
                } else {
                    this.curentContent = 0;
                }
                this.cdr.detectChanges();
            });
        }, 50);
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    sendAnmeldung() {
        this.sendReg.emit(true);
    }

    gotoVideos() {
        document.getElementById('c-videos')?.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }

    gotoDesc() {
        document.getElementById('cDesc')?.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
}
